import BackButton from "./BackButton"

const PageHeader = ({ backTo, pageName }) => {
  return (
    <div className="admin-page-header">
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        {backTo && <BackButton backTo={backTo} />}
      </div>
      <div /> {/* Spacer for center */}
      <div className="page-name" style={{ gridColumn: 3, textAlign: 'right' }}>{pageName}</div>
    </div>
  )
}

export default PageHeader